import React from "react";
import { Modal, Box } from "@mui/material";
import CtaComponent from "../cta";
import { CTA_SIZE, CTA_TYPE } from "../../../data/constants";

interface Props {
  headingText?: string;
  description?: string;
  onModalClose: any;
  onConfirmBtnClick: any;
  customClass?: string;
  showCloseIcon?: boolean;
  iconName?: string;
  ctaProps?: { confirmText: string; cancelText: string };
}

const ConfirmationModal = (props: Props) => {
  const { headingText, description, onModalClose, onConfirmBtnClick, customClass = '', showCloseIcon = true, iconName = '', ctaProps = { confirmText: "YES", cancelText: "NO" } } = props;
  return (
    <Modal
      open={true}
      onClose={onModalClose}
      aria-labelledby="child-modal-title"
      aria-describedby="child-modal-description"
    >
      <Box className={`modal-center py-10 px-20 pb-20 ${customClass}`}>
        {iconName && <div className={`rista-sprite ${iconName} mb-[15px]`}></div>}  
        <div className="flex justify-between items-center">
          {headingText ? <h2 className="text-18 font-semibold">{headingText}</h2> : null}
          {showCloseIcon && <div className="rista-sprite ic-cross-black" onClick={onModalClose}></div>}
        </div>
        {
          description ?
            <p className="text-14 font-normal mb-40 mt-12">
              {description}
            </p>
            : null
        }
        <div className="flex justify-end">
          <CtaComponent
            ctaSize={CTA_SIZE.medium}
            ctaText={ctaProps.confirmText}
            ctaType={CTA_TYPE.secondary_cta}
            onCtaClick={onConfirmBtnClick}
            customClass={"mr-12"}
          ></CtaComponent>
          <CtaComponent
            ctaSize={CTA_SIZE.medium}
            ctaText={ctaProps.cancelText}
            ctaType={CTA_TYPE.active_cta}
            onCtaClick={onModalClose}
          ></CtaComponent>
        </div>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;